/* eslint-disable camelcase */
import crypto from 'crypto-js';

export default {
  init({ appId, identityVerificationSecret, user }) {
    if (document.getElementById('intercom')) {
      return;
    }

    // eslint-disable-next-line new-cap
    const hash = crypto.HmacSHA256(user.id, identityVerificationSecret);
    const intercomHash = crypto.enc.Hex.stringify(hash);
    const intercomSettings = JSON.stringify({
      app_id: appId,
      user_hash: intercomHash,
      user_id: user.id,
      name: user.name,
      email: user.email,
    });

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'intercom';
    script.innerHTML = `
      window.intercomSettings = ${intercomSettings};
      (function loadInterCom() {
        const w = window;
        const ic = w.Intercom;
        if (typeof ic === 'function') {
          ic('reattach_activator');
          ic('update', w.intercomSettings);
        } else {
          const d = document;
          var i = function() {
            i.c(arguments);
          };
          i.q = [];
          i.c = function(args) {
            i.q.push(args);
          };
          w.Intercom = i;
          const l = function() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + window.intercomSettings.app_id;
            const x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === 'complete') {
            l()
          } else if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      })();
    `;

    document.body.appendChild(script);
  },
};
